import { createQueryKeys } from '@lukemorales/query-key-factory';

import API from '../../index';
import { GetGuidelinesRequestParams } from './guidelines.types';

export const guidelinesQueryKeys = createQueryKeys('guidelines', {
  getGuidelines: (params: GetGuidelinesRequestParams) => ({
    queryKey: [{ params }],
    queryFn: () => API.Guidelines.index(params),
  })
});
